import http from '../http'

/**
 * 小程序平台用户管理接口。
 *
 * 业务手机号仅用于搜索真实业务身份，平台用户授权始终以微信会话绑定关系为准。
 */
export async function fetchMiniappUserPage(params = {}) {
    return await http.get('/system/miniapp-users', {params})
}

export async function fetchMiniappUserDetail(id) {
    return await http.get(`/system/miniapp-users/${id}`)
}

export async function createMiniappPendingUser(payload) {
    return await http.post('/system/miniapp-users', payload)
}

export async function addMiniappUserRole(id, payload) {
    return await http.post(`/system/miniapp-users/${id}/roles`, payload)
}

export async function removeMiniappUserRole(id, roleId) {
    return await http.delete(`/system/miniapp-users/${id}/roles/${roleId}`)
}

export async function createMiniappUserInvitation(id, payload = {validityHours: 24}) {
    return await http.post(`/system/miniapp-users/${id}/invitations`, payload)
}

export async function unbindMiniappUserWechat(id) {
    return await http.post(`/system/miniapp-users/${id}/unbind-wechat`)
}

export async function fetchMiniappIdentityCandidates(params = {}) {
    return await http.get('/system/miniapp-users/identity-candidates', {params})
}
